import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagMarcasFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagMarcas'>
      {({ field }) => <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagMarcas' label='Uso de marcas' />}
    </Field>
  )
}

export default React.memo(FlagMarcasFormGroup)
